import { render, staticRenderFns } from "./ScoreInputSetting.vue?vue&type=template&id=34f19bcb"
import script from "./ScoreInputSetting.vue?vue&type=script&lang=js"
export * from "./ScoreInputSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports